module.exports = __webpack_public_path__ + "static/media/cover.eba39526.png";